import { FC, useMemo } from 'react';

import { cn } from 'src/utils/utility';
import { IChipBasicProps } from './types';

export const ChipBasic: FC<IChipBasicProps> = (props) => {
  const { label, icon, variant = 'success', size = 'medium', className } = props;

  const rootStyles = useMemo(() => {
    switch (variant) {
      case 'success':
        return 'bg-[#DCEFE6] text-green-50';
      case 'warning':
        return 'bg-[#FAEFE5] text-orange-30';
      case 'danger':
        return 'bg-[#F8E1E9] text-red-40';
      default:
        return 'bg-[#F5F6FA] text-neutral-50';
    }
  }, [variant]);

  const rootSizeStyles = useMemo(() => {
    switch (size) {
      case 'large':
        return `pr-16 py-4 ${icon ? 'pl-4' : 'pl-16'}`;
      default:
        return `pr-12 py-2 ${icon ? 'pl-2' : 'pl-12'}`;
    }
  }, [icon, size]);

  // Both sizes use the same text size
  const labelStyles = useMemo(() => 'text-12 xl:text-14', []);

  return (
    <div className={cn('relative flex items-center gap-6 rounded-full', rootSizeStyles, rootStyles, className)}>
      {icon && <img src={icon} alt='' className='w-16' />}
      <strong className={cn('font-medium uppercase', labelStyles)}>{label}</strong>
    </div>
  );
};
